// ---------------------------------------------------------------------------
// Idő a nap skáláján
//
// A nyitvatartás átnyúlik éjfélen, ezért a hajnali órák a nap végére kerülnek: 01:00 = 25.
// óra. Enélkül a 22:00-01:00 zárás üres tartomány lenne, egy 00:00-kor kezdődő foglalás pedig
// a nap elejére kerülne. Az éjszakai szabály EGY helyen él: a rács (`laneGrid.ts`), az
// átfedés-vizsgálat (`pricing.ts`), a foglalás-listák rendezése (`bookingSearch.ts`) és a
// pálya napja (`dayKeyAt`) is innen olvas. Szándékosan levél-modul, importok nélkül: a
// `pricing.ts` a `laneGrid.ts`-et nem importálhatja (az importálja őt).
// ---------------------------------------------------------------------------

export const HOURS_PER_DAY = 24;

/**
 * Eddig tart az „előző naphoz” tartozó éjszaka: a rács hajnali órái és a pálya napja
 * (`dayKeyAt`, az admin keret „mai napja”) is ehhez igazodik.
 */
export const NIGHT_END_HOUR = 6;

const parseHour = (time: string): number => parseInt(time.split(":")[0], 10);

/** A tárolt alakból a nap skálájára: „01:00” -> 25. */
export const toDayScaleHour = (time: string): number => {
  const hour = parseHour(time);
  return hour < NIGHT_END_HOUR ? hour + HOURS_PER_DAY : hour;
};

/** Ugyanez percben, a perc is számít: „01:30” -> 25 * 60 + 30. */
export const toDayScaleMinutes = (time: string): number =>
  toDayScaleHour(time) * 60 + (Number(time.split(":")[1]) || 0);

/** Vissza a nap skálájáról a tárolt alakra: 25 -> „01:00”. */
export const fromDayScaleHour = (hour: number): string =>
  `${String(hour % HOURS_PER_DAY).padStart(2, "0")}:00`;
